import { useMutation, useQuery } from '@tanstack/react-query'
import { postNamedCommand, postNamedQuery } from '../../service'

export const useCreateOutboundRedirect = () => {
  return useMutation({
    mutationFn: async ({ to, from, purpose, label, method }) => {
      const { data } = await postNamedCommand('users', 'create-outbound-redirect', {
        to,
        from,
        purpose,
        label,
        method
      })

      return data
    }
  })
}

export const useOutboundRedirect = (redirectId) => {
  return useQuery({
    queryKey: ['users/get-outbound-redirect', redirectId],
    enabled: !!redirectId,
    queryFn: async () => {
      const result = await postNamedQuery('users', 'get-outbound-redirect', {
        redirectId
      })

      return result.data
    }
  })
}
